import styled from 'styled-components';
import { Image as AntdImage } from 'antd';

const Image = styled(AntdImage)`
  width: 100%;
  margin-top: 32px;
`;

export default Image;
